// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { GeoJsonEditMode } from "./geojson-edit-mode.js";
export class ThreeClickPolygonMode extends GeoJsonEditMode {
    handleClick(event, props) {
        this.addClickSequence(event);
        const clickSequence = this.getClickSequence();
        const tentativeFeature = this.getTentativeGuide(props);
        if (clickSequence.length > 2 &&
            tentativeFeature &&
            tentativeFeature.geometry.type === 'Polygon') {
            const editAction = this.getAddFeatureOrBooleanPolygonAction(tentativeFeature.geometry, props);
            this.resetClickSequence();
            if (editAction) {
                props.onEdit(editAction);
            }
        }
    }
    getGuides(props) {
        const { lastPointerMoveEvent, modeConfig } = props;
        const clickSequence = this.getClickSequence();
        const guides = {
            type: 'FeatureCollection',
            features: []
        };
        if (clickSequence.length === 0) {
            // nothing to do yet
            return guides;
        }
        const hoveredCoord = lastPointerMoveEvent.mapCoords;
        if (clickSequence.length === 1) {
            guides.features.push({
                type: 'Feature',
                properties: {
                    guideType: 'tentative'
                },
                geometry: {
                    type: 'LineString',
                    coordinates: [clickSequence[0], hoveredCoord]
                }
            });
        }
        else {
            const polygon = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], hoveredCoord, modeConfig);
            if (polygon) {
                guides.features.push({
                    type: 'Feature',
                    properties: {
                        guideType: 'tentative'
                    },
                    geometry: polygon.geometry
                });
            }
        }
        return guides;
    }
    getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
        return null;
    }
    handlePointerMove(event, props) {
        props.onUpdateCursor('cell');
        super.handlePointerMove(event, props);
    }
    createTentativeFeature(props) {
        const { lastPointerMoveEvent } = props;
        const clickSequence = this.getClickSequence();
        const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
        let tentativeFeature;
        if (clickSequence.length === 2) {
            tentativeFeature = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], lastCoords[0], props.modeConfig);
        }
        return tentativeFeature;
    }
}
